export const makeChannelAuthorizer = (authorize)=>(params, callback)=>{
        authorize(params).then((data)=>callback(null, data)).catch((error)=>callback(error instanceof Error ? error : new Error('pusher channel authorization failed'), null));
    };
